import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Menu = props => (
  <nav id="menu">
    <div className="inner">
      <ul className="links">
        <li>
          <Link onClick={props.onToggleMenu} to="/">
            Home
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/aboutUs">
            關於我們
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/news">
            最新消息
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/serviceItem">
            場館介紹
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/lesson">
            課程介紹
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/404">
            會員成果
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/question">
            常見問題
          </Link>
        </li>
      </ul>
    </div>
    <a className="close" onClick={props.onToggleMenu} href="javascript:;">
      Close
    </a>
  </nav>
)

Menu.propTypes = {
  onToggleMenu: PropTypes.func,
}

export default Menu
